"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipExtension = exports.TooltipBehavior = exports.DefaultTooltipExtensionParams = void 0;
var tslib_1 = require("tslib");
var class_names_1 = require("../class-names");
var extension_1 = require("../extension");
var scales_1 = require("../scales");
var utils_1 = require("../utils");
function DefaultTooltipProvider(datum, x, y, xIndex, yIndex) {
  return "x: ".concat(JSON.stringify(x), " (index ").concat(xIndex, ") <br> y: ").concat(JSON.stringify(y), " (index ").concat(yIndex, ") <br> datum: ").concat(JSON.stringify(datum));
}
/** Default parameter values for `TooltipExtension` */
exports.DefaultTooltipExtensionParams = {
  tooltipProvider: DefaultTooltipProvider,
  pinnable: true
};
/** Behavior class for `TooltipExtension` (shows a box with tooltip when hovering and/or clicking on a grid cell with data) */
var TooltipBehavior = /** @class */function (_super) {
  tslib_1.__extends(TooltipBehavior, _super);
  function TooltipBehavior() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** Position of the pinned tooltip, if any. In world coordinates, continuous. Use `Math.floor` to get column/row index. */
    _this.pinnedTooltip = undefined;
    return _this;
  }
  TooltipBehavior.prototype.register = function () {
    var _this = this;
    _super.prototype.register.call(this);
    this.subscribe(this.state.events.hover, function (pointed) {
      return _this.drawTooltip(pointed);
    });
    this.subscribe(this.state.events.select, function (pointed) {
      return _this.drawPinnedTooltip(pointed);
    });
    this.subscribe(this.state.events.zoom, function () {
      return _this.updatePinnedTooltipPosition();
    });
    this.subscribe(this.state.events.resize, function () {
      return _this.updatePinnedTooltipPosition();
    });
  };
  /** Add a div with tooltip or update position of existing tooltip, for the `pointed` grid cell.
   * Remove existing tooltip, if `pointed` is `undefined`. */
  TooltipBehavior.prototype.drawTooltip = function (pointed) {
    var _a;
    if (!this.state.dom) return;
    var thisTooltipPinned = pointed.cell && this.pinnedTooltip && pointed.cell.xIndex === Math.floor(this.pinnedTooltip.x) && pointed.cell.yIndex === Math.floor(this.pinnedTooltip.y);
    if (((_a = pointed.cell) === null || _a === void 0 ? void 0 : _a.datum) !== undefined && !thisTooltipPinned && this.params.tooltipProvider && pointed.sourceEvent) {
      var tooltipPosition = this.getTooltipPosition(pointed.sourceEvent);
      var tooltipText = this.params.tooltipProvider(pointed.cell.datum, pointed.cell.x, pointed.cell.y, pointed.cell.xIndex, pointed.cell.yIndex);
      var tooltip = this.state.dom.canvasDiv.selectAll('.' + class_names_1.Class.TooltipBox);
      if (tooltip.empty()) {
        // Create tooltip if doesn't exist
        tooltip = (0, utils_1.attrd)(this.state.dom.canvasDiv.append('div'), {
          class: class_names_1.Class.TooltipBox,
          style: tslib_1.__assign({
            position: 'absolute'
          }, tooltipPosition)
        });
        (0, utils_1.attrd)(tooltip.append('div'), {
          class: class_names_1.Class.TooltipContent
        }).html(tooltipText);
      } else {
        // Update tooltip position and content if exists
        (0, utils_1.attrd)(tooltip, {
          style: tooltipPosition
        }).select('.' + class_names_1.Class.TooltipContent).html(tooltipText);
      }
    } else {
      this.state.dom.canvasDiv.selectAll('.' + class_names_1.Class.TooltipBox).remove();
    }
  };
  /** Add a div with pinned tooltip or update position of existing pinned tooltip, for the `pointed` grid cell.
   * Remove existing pinned tooltip, if `pointed` is `undefined`.
   * Pinned tooltip is shown when the user selects a cell by clicking,
   * and stays visible until it is closed by close button or clicking elsewhere. */
  TooltipBehavior.prototype.drawPinnedTooltip = function (pointed) {
    var _this = this;
    var _a;
    if (!this.state.dom) return;
    this.state.dom.canvasDiv.selectAll('.' + class_names_1.Class.PinnedTooltipBox).remove();
    if (((_a = pointed.cell) === null || _a === void 0 ? void 0 : _a.datum) !== undefined && this.params.tooltipProvider && this.params.pinnable && pointed.sourceEvent) {
      this.pinnedTooltip = {
        x: this.state.scales.svgToWorld.x(pointed.sourceEvent.offsetX),
        y: this.state.scales.svgToWorld.y(pointed.sourceEvent.offsetY)
      };
      var tooltipPosition = this.getTooltipPosition(pointed.sourceEvent);
      var tooltipText = this.params.tooltipProvider(pointed.cell.datum, pointed.cell.x, pointed.cell.y, pointed.cell.xIndex, pointed.cell.yIndex);
      var tooltip = (0, utils_1.attrd)(this.state.dom.canvasDiv.append('div'), {
        class: class_names_1.Class.PinnedTooltipBox,
        style: tslib_1.__assign({
          position: 'absolute'
        }, tooltipPosition)
      });
      // Tooltip content
      (0, utils_1.attrd)(tooltip.append('div'), {
        class: class_names_1.Class.PinnedTooltipContent
      }).html(tooltipText);
      // Tooltip close button
      (0, utils_1.attrd)(tooltip.append('div'), {
        class: class_names_1.Class.PinnedTooltipClose
      }).on('click.TooltipExtension', function (e) {
        return _this.state.events.select.next({
          cell: undefined,
          sourceEvent: e
        });
      }).append('svg').attr('viewBox', '0 0 24 24').attr('preserveAspectRatio', 'none').append('path').attr('d', 'M19,6.41 L17.59,5 L12,10.59 L6.41,5 L5,6.41 L10.59,12 L5,17.59 L6.41,19 L12,13.41 L17.59,19 L19,17.59 L13.41,12 L19,6.41 Z');
      // Tooltip pin
      (0, utils_1.attrd)(tooltip.append('svg'), {
        class: class_names_1.Class.PinnedTooltipPin
      }).attr('viewBox', '0 0 100 100').attr('preserveAspectRatio', 'none').append('path').attr('d', 'M0,100 L100,40 L60,0 Z');
      // Remove any non-pinned tooltip
      this.drawTooltip({
        cell: undefined,
        sourceEvent: pointed.sourceEvent
      });
    } else {
      this.pinnedTooltip = undefined;
    }
  };
  /** Update position of existing pinned tooltip without changing content (used when zooming/resizing canvas). */
  TooltipBehavior.prototype.updatePinnedTooltipPosition = function () {
    if (this.state.dom && this.pinnedTooltip) {
      var domPosition = {
        offsetX: this.state.scales.worldToSvg.x(this.pinnedTooltip.x),
        offsetY: this.state.scales.worldToSvg.y(this.pinnedTooltip.y)
      };
      (0, utils_1.attrd)(this.state.dom.canvasDiv.selectAll('.' + class_names_1.Class.PinnedTooltipBox), {
        style: this.getTooltipPosition(domPosition)
      });
    }
  };
  ;
  /** Return tooltip position as CSS style parameters (for position:absolute within this.canvasDiv) for mouse event `e` triggered on this.svg.  */
  TooltipBehavior.prototype.getTooltipPosition = function (e) {
    var _a, _b;
    var left = "".concat((_a = e.offsetX) !== null && _a !== void 0 ? _a : 0, "px");
    var bottom = "".concat(scales_1.Box.height(this.state.boxes.svg) - ((_b = e.offsetY) !== null && _b !== void 0 ? _b : 0), "px");
    var display = scales_1.Box.containsPoint(this.state.boxes.svg, {
      x: e.offsetX,
      y: e.offsetY
    }) ? 'unset' : 'none';
    return {
      left: left,
      bottom: bottom,
      display: display
    };
  };
  return TooltipBehavior;
}(extension_1.BehaviorBase);
exports.TooltipBehavior = TooltipBehavior;
/** Adds behavior that shows a box with tooltip when hovering and/or clicking on a grid cell with data */
exports.TooltipExtension = extension_1.Extension.fromBehaviorClass({
  name: 'builtin.tooltip',
  defaultParams: exports.DefaultTooltipExtensionParams,
  behavior: TooltipBehavior
});